import { TeamMember } from "@/server/backend-api";
import { mcn } from "@/utils/mergeClassNames";
import { PersonaCoin } from "./PersonaCoin";

type Role = "Teacher" | "Learner";

type Props = {
  className?: string;
  person: TeamMember;
  teamRole: Role;
  teacherLabel?: string;
};

export const TeamMemberCard = ({
  className,
  person,
  teamRole,
  teacherLabel = "Teacher",
}: Props) => {
  const label = teamRole === "Teacher" ? teacherLabel : "Learner";
  return (
    <div
      className={mcn(
        "bg-blue text-white rounded-2",
        teamRole === "Learner" && "rounded-l-[64px]",
        teamRole === "Teacher" ? "rounded-2" : "rounded-3 rounded-l-[64px]",

        "flex items-center",
        teamRole === "Teacher" ? "gap-2xs" : "gap-md",
        teamRole === "Teacher" && "flex-col text-center",
        teamRole === "Teacher" ? "py-md px-md" : "py-2xs px-2xs",
        className
      )}
    >
      <PersonaCoin
        className="flex-shrink-0"
        size="56"
        displayName={person.displayName}
        imageUrl={person.imageUrl}
      />
      <div className="overflow-hidden w-full ">
        <div className="text-style-subtitle2 truncate">
          {person.displayName}
        </div>
        <div className="text-style-caption">{label}</div>
      </div>
    </div>
  );
};